import { getPrintTaskClientMode } from '@/api/report/printTaskV2'

// 运行时模式不落本地缓存；浏览器刷新后会重新向服务端确认一次。
let clientMode = 'legacy'
let initialized = false
let pending = null

export function getPrintTaskClientModeValue() {
  return clientMode
}

export function isLegacyPrintTaskMode() {
  return clientMode === 'legacy'
}

export async function initPrintTaskMode() {
  if (initialized) return clientMode
  if (pending) return pending

  pending = getPrintTaskClientMode().then(res => {
    const value = res && res.data && res.data.mode ? String(res.data.mode) : ''
    clientMode = value.trim().toLowerCase() === 'legacy' ? 'legacy' : 'v2'
  }).catch(error => {
    // 后端尚未发布新接口或临时异常时，安全回到旧导出流程。
    clientMode = 'legacy'
    console.warn('获取批量打印模式失败，使用legacy流程', error)
  }).finally(() => {
    initialized = true
    pending = null
  })
  return pending
}
